<template>
  <v-content class="candidate profile page">
    <v-container>
      <v-card width="100%" max-width="900px" style="margin: auto;">
        <ProfileWizard @preview="viewing = true" @signup="$emit('signup')" />
      </v-card>

      <!-- View Profile -->
      <v-dialog
        v-model="viewing"
        :fullscreen="$vuetify.breakpoint.smAndDown"
        max-width="850"
        :scrollable="$vuetify.breakpoint.mdAndUp"
        lazy
      >
        <ProfilePreview @close="viewing = false" />
      </v-dialog>
    </v-container>
  </v-content>
</template>

<script>
// Mixins
import { managedDocumentAttributes } from '@/mixins/managedDocumentAttributes'

// Components
import ProfileWizard from '@/components/candidate/profile/edit/ProfileWizard'
import ProfilePreview from '@/components/candidate/profile/ProfilePreview'

// Helpers
import { mapGetters } from 'vuex'
const bodyScroll = require('body-scroll-toggle')

// Vue Component
export default {
  mixins: [managedDocumentAttributes],

  components: { ProfileWizard, ProfilePreview },

  created() {
    this.documentAttributes.title = 'Candidate Profile - Leaply'
    this.openPreviewFromHash(this.$route.hash)
  },

  data() {
    return {
      viewing: false,
      ready: false,
    }
  },

  watch: {
    '$route.hash': {
      handler(hash) {
        this.openPreviewFromHash(hash)
      },
    },
    viewing: function(value) {
      // When the modal is shown
      if (value) {
        bodyScroll.disable()
      }

      // When the modal is hidden
      if (!value) {
        bodyScroll.enable()
      }
    },
  },

  methods: {
    openPreviewFromHash(hash) {
      if (hash === '#view') this.viewing = true
    },
  },
}
</script>
